import { getWechatShareParams } from "@/api/centerLogin";

export const commomShare = (title, link, imgurl, desc,callback) => {
    let urlPathLink = (location.href.split("#")[0] || "");

    getWechatShareParams({ url: urlPathLink }).then(res => {

        if (res.code == 200) {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.appId, //res.data.appId, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData','onMenuShareWechat','onMenuShareAppMessage','onMenuShareTimeline'] ,// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                openTagList: ['wx-open-launch-weapp'] // 跳转小程序时必填
            });
            wx.checkJsApi({
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                openTagList: ['wx-open-launch-weapp'], // 跳转小程序时必填
                success: function () {

                    // 以键值对的形式返回，可用的api值true，不可用为false
                    // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                }
            });
            wx.error(function (res) {
                console.error(res)
            });

            wx.ready(function () {
                wx.onMenuShareTimeline({
                    title: title,   // 分享时的标题
                    link: link,     // 分享时的链接 // keyi
                    imgUrl: imgurl,   // 分享时的图标
                    desc: desc,
                    success: function () {
                        console.log("分享成功");
                    },
                    cancel: function () {
                        console.log("取消分享");
                    }
                });
                wx.updateTimelineShareData({
                    title: title,   // 分享时的标题
                    link: link,     // 分享时的链接 // keyi
                    imgUrl: imgurl,   // 分享时的图标
                    desc: desc,
                    type: 'link',
                    success: function () {
                        console.log("分享成功");
                    },
                    cancel: function () {
                        console.log("取消分享");
                    }
                });
                wx.onMenuShareAppMessage({
                    title: title,   // 分享时的标题
                    link: link,     // 分享时的链接 // keyi
                    imgUrl: imgurl,   // 分享时的图标
                    desc: desc,
                    success: function () {

                    },
                    complete: function (n) {
                    }
                });
                // wx.getLocation({
                //   type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                //   success: function (res) {
                //     console.log("33343434分享成功", res);
                //     var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                //     var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                //     var speed = res.speed; // 速度，以米/每秒计
                //     var accuracy = res.accuracy; // 位置精度
                //   }
                // });
                wx.updateAppMessageShareData({
                    title: title,   // 分享时的标题
                    link: link,     // 分享时的链接 // keyi
                    imgUrl: imgurl,   // 分享时的图标
                    desc: desc,
                    type: 'link',
                    success: function () {
                        callback(true)

                    },
                    complete: function (n) {

                    }
                });
            })
        }
    })
}

